/** local storage key: ホットライン 企業 クリップ機能 */
export const LOCAL_STORAGE_KEY_HOTLINE_CLIENT_NEGOTIATE_CLIP = 'hotline-client-negotiate-clip-key';
